// EVENTS.VIEWS.USER.FORGOT_PASSWORD

export const FORGOT_PASSWORD = {
  PAGE_VISITED: 'forgot_password-page_visited',
  RESET_BUTTON: 'reset-actioned_button',
  BACK_BUTTON: 'back_to_login-actioned_button'
};
